export const Medallion = ({ icon: Icon, size = 64, testId }) => (
  <div className="medallion" style={{ width: size, height: size }} data-testid={testId}>
    <div className="medallion-inner">
      <Icon
        strokeWidth={1.6}
        style={{ width: size * 0.42, height: size * 0.42 }}
        className="text-brand"
      />
    </div>
  </div>
);
